module.exports = __webpack_public_path__ + "static/learn-logo-banner-d1920bfbf7656bc5dc0066e9bd40f54f.png";